export default "__VITE_ASSET__48161c1c__"